<template>
  <div class="page">
    <div class="page-header">
      <h2 class="page-title">支付记录</h2>
    </div>

    <div class="table-card">
      <el-table
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)"
        element-loading-svg-view-box="-10, -10, 80, 80"
        :element-loading-svg="loadingSvg"
        :data="payRecords"
        class="data-table"
        empty-text="暂无支付记录"
      >
        <el-table-column label="#" width="60" align="center">
          <template #default="scope">
            <span class="row-num">{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" min-width="280" show-overflow-tooltip>
          <template #default="scope">
            <span class="cell-text">{{ scope.row.orderCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="180" show-overflow-tooltip>
          <template #default="scope">
            <span class="cell-meta">{{ scope.row.titleName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="110" align="center">
          <template #default="scope">
            <span class="cell-tag" :class="scope.row.payBizType === '00' ? 'song' : 'vip'">
              {{ scope.row.payBizType === '00' ? '歌曲购买' : '会员购买' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="应付" width="100" align="right">
          <template #default="scope">
            <span class="cell-price">¥{{ scope.row.payAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实付" width="100" align="right">
          <template #default="scope">
            <span class="cell-price actual">¥{{ scope.row.actualPayAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" min-width="170">
          <template #default="scope">
            <span class="cell-time">{{ scope.row.callbackTime }}</span>
          </template>
        </el-table-column>
      </el-table>

      <CustomPagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        :page-size-options="[10, 20, 30, 50]"
        @change="handlePaginationChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { HttpManager } from '@/api'
import CustomPagination from '@/components/common/CustomPagination.vue'

const payRecords = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)

const loadingSvg = `
  <svg xmlns="http://www.w3.org/2000/svg">
    <image href="/20250706Logo.png" width="45" height="45" x="7" y="7" preserveAspectRatio="xMidYMid meet"/>
  </svg>
`;

const fetchPayRecords = async () => {
  loading.value = true
  try {
    const response = await HttpManager.getLoginUserPayInfoPage({
      page: currentPage.value,
      size: pageSize.value
    })
    payRecords.value = response.data.data
    total.value = response.data.total
  } catch (error) {
    console.error('获取支付记录失败:', error)
  } finally {
    loading.value = false
  }
}

const handlePaginationChange = (page: number, size: number) => {
  currentPage.value = page
  pageSize.value = size
  fetchPayRecords()
}

onMounted(() => { fetchPayRecords() })
</script>

<style lang="scss" scoped>
.page {
  max-width: 1300px;
  margin: 0 auto;
  padding: 48px 24px 100px;
  min-height: 100vh;
  background: #262626;
}

.page-header {
  margin-bottom: 28px;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.table-card {
  background: rgba(255,255,255,0.025);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
  padding: 20px;
}

/* table */
:deep(.data-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-header-bg-color: transparent;

  &::before { height: 0; }

  .el-table__header th {
    background: transparent;
    color: rgba(255,255,255,0.4);
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    padding: 10px 0;
  }

  .el-table__body td {
    border-bottom: 1px solid rgba(255,255,255,0.04);
    padding: 14px 0;
  }

  .el-table__row:hover > td {
    background: rgba(255,255,255,0.02) !important;
  }
}

.row-num {
  color: rgba(255,255,255,0.25);
  font-size: 13px;
}

.cell-text { white-space: nowrap;
  color: rgba(255,255,255,0.75);
  font-size: 13px;
}

.cell-time {
  color: rgba(255,255,255,0.4);
  font-size: 13px;
}

.cell-price {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  &.actual { color: #1ed760; }
}

.cell-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  &.song {
    background: rgba(30,215,96,0.1);
    color: #1ed760;
  }
  &.vip {
    background: rgba(230,162,60,0.1);
    color: #e6a23c;
  }
}

/* loading */
:deep(.el-loading-mask) {
  background: rgba(38,38,38,0.85) !important;
}
:deep(.el-loading-spinner .path) {
  stroke: #1ed760;
}
:deep(.el-loading-text) {
  color: rgba(255,255,255,0.4);
}
</style>
